"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendNow = exports.getFlesher = exports.setFlesher = exports.getConfig = exports.setConfig = exports.getBatcher = exports.setBatcher = exports.getAll = exports.ElevioEvents = exports.Batch = exports.getSender = void 0;
var events_1 = require("./events");
Object.defineProperty(exports, "ElevioEvents", { enumerable: true, get: function () { return events_1.ElevioEvents; } });
var sender_1 = require("./sender");
exports.getSender = sender_1.default;
var batch_1 = require("./batch");
exports.Batch = batch_1.default;
var pageStats_1 = require("./pageStats");
Object.defineProperty(exports, "getAll", { enumerable: true, get: function () { return pageStats_1.getAll; } });
var _batch;
function setBatcher(batch) {
    _batch = batch;
}
exports.setBatcher = setBatcher;
function getBatcher() {
    return _batch;
}
exports.getBatcher = getBatcher;
var _config;
function setConfig(config) {
    _config = config;
}
exports.setConfig = setConfig;
function getConfig() {
    return _config;
}
exports.getConfig = getConfig;
var _flesher;
function setFlesher(flesher) {
    _flesher = flesher;
}
exports.setFlesher = setFlesher;
function getFlesher() {
    return _flesher;
}
exports.getFlesher = getFlesher;
function alterEvent(event, opts) {
    if (opts.force_timestamp) {
        return __assign(__assign({}, event), { timestamp_created: opts.force_timestamp, timestamp_server: opts.force_timestamp });
    }
    return event;
}
/**
 * This is the thing that adds the event to the dispatch queue.
 */
function track(event, opts) {
    if (!_batch)
        throw new Error("Batcher hasn't been set yet");
    if (!_config)
        throw new Error("Config hasn't been set yet");
    if (_config.isDisabled)
        return;
    // So we can change the event without modifying the original
    var myEvent = __assign({}, event);
    myEvent = opts ? alterEvent(myEvent, opts) : myEvent;
    if (_config.isAnonMode) {
        delete myEvent.page_url;
        delete myEvent.page_referrer;
        delete myEvent.user_id_external;
    }
    if (typeof myEvent.custom_attributes === "object") {
        myEvent.custom_attributes = JSON.stringify(myEvent.custom_attributes);
    }
    _batch.addEvent(myEvent);
}
exports.default = track;
/**
 * This sends the events without using the batching q.
 * It returns a promise so you can wait for it and will throw an error if it fails.
 * @param events the array of events to send.
 */
function sendNow(events, opts) {
    if (!_config)
        throw new Error("Config hasn't been set yet");
    if (_config.isDisabled)
        return Promise.resolve();
    var _events = opts ? events.map(function (e) { return alterEvent(e, opts); }) : events;
    return sender_1.promiseSender(_events);
}
exports.sendNow = sendNow;
